var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { injectable } from '../../Decorators/Injectable';
import { inject } from '../../Decorators/Inject';
import { IEventsDataSourceType } from '../EventsDataSource/IEventsDataSource';
import { IAPIHTTPDataSourceType } from '../APIHTTPDataSource/IAPIHTTPDataSource';
import { BaseAnalyticsDataSource } from './BaseAnalyticsDataSource';
import { parseNumberToString } from '../../../Helpers/ParseNumberToString/ParseNumberToString';
import { Platform } from 'react-native';
let AnalyticsDataSource = class AnalyticsDataSource extends BaseAnalyticsDataSource {
    constructor(eventsDataSource, apiHTTPDataSource) {
        super(apiHTTPDataSource);
        this.eventsDataSource = eventsDataSource;
        this.apiHTTPDataSource = apiHTTPDataSource;
    }
    sendScreenEvent(data) {
        this.sendInternalScreenEvent(data);
        return Promise.resolve();
    }
    sendEvent(module, event, data) {
        const updatedData = parseNumberToString(data);
        this.sendInternalEvent(event, data);
        if (!this.is_enabled || !window.dataLayer) {
            this.eventsDataSource.sendEvent(module, {
                module,
                event: 'track',
                data: { event, data: updatedData }
            });
            return Promise.resolve();
        }
        if (window.dataLayer && this.is_enabled_by_user) {
            window.dataLayer.push(Object.assign({ event, device: Platform.OS }, (data || {})));
        }
        return Promise.resolve();
    }
};
AnalyticsDataSource = __decorate([
    injectable({ type: 'singleton' }),
    __param(0, inject(IEventsDataSourceType)),
    __param(1, inject(IAPIHTTPDataSourceType)),
    __metadata("design:paramtypes", [Object, Object])
], AnalyticsDataSource);
export { AnalyticsDataSource };
